import React from "react";
import { withStyles } from "@material-ui/core";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker } from "react-date-range";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
const styles = (theme) => ({
  selectDate: {
    minHeight: "36px",
    fontSize: "12px",
    margin: "10px 10px",
    color: theme.TextColor,
    display: "flex",
    flexDirection: "column-reverse",
    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.2)",
    "& .rdrDefinedRangesWrapper": {
      width: "100%",
      border: "none",
      "& .rdrStaticRanges": {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        border: "none",
        marginTop: 24,
      },
    },
    "& .rdrMonth": {
      padding: 0,
    },
    "& .rdrDays button": {
      height: "3.5em",
    },
    "& .rdrStaticRange": {
      border: `1px solid ${theme.iconColor}`,
      borderRadius: "20px",
    },
    "& .rdrStaticRange:hover .rdrStaticRangeLabel,.rdrStaticRange:focus .rdrStaticRangeLabel":
      {
        background: theme.palette.primary.main,
        color: theme.satelliteViewRouteColor,
        borderRadius: "20px",
      },
  },
});

class DateRange extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    document.addEventListener("keydown", this.hideOnEscape);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.hideOnEscape);
  }

  hideOnEscape = (e) => {
    if (e.key === "Escape") {
      this.props.handleClose();
    }
  };
  render() {
    const { classes, ...otherProps } = this.props;
    return (
      <ClickAwayListener onClickAway={this.props.handleClose}>
        <DateRangePicker className={classes.selectDate} {...otherProps} />
      </ClickAwayListener>
    );
  }
}

export default withStyles(styles)(DateRange);
